module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_25-fadd32f449debde3f66a81b053a0d91b.jpg";